import { Component } from "react";

class FileAttachment extends Component {
	constructor(props) {
		super(props);
		this.state = {
			attachmentId: "",
			file: null,
			isPublic: true,
			url: "",
			errors: [],
			isPdf: false
		};
		this.handleChange = this.handleChange.bind(this);
	}
	handleChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
}

export default FileAttachment;
